import React from 'react';
import { FileUploaderInput, usePopupFormManager } from 'features/nekst-widgets';
import {
  AfterSubmitFunc,
  Button,
  ButtonColor,
  ButtonSize,
  FormTemplate,
  IconType,
  TextInput,
} from 'ui-builder';
import { CreateDocumentLabelRequest, FileType, useDocumentLabelsService } from 'nekst-api';

export default function CreateDocumentLabelForm(
  props: {
    afterSubmitFunc?: AfterSubmitFunc
  },
) {
  const service = useDocumentLabelsService();
  return (
    <FormTemplate<CreateDocumentLabelRequest>
      title="Create Label"
      submitFormFunc={(data) => service.createLabel(data)}
      afterSubmitFunc={props.afterSubmitFunc}
      validationSchema={{
        name: {
          type: 'string',
          constraints: {
            required: true,
          },
        },
      }}
    >
      <TextInput source="name" label="Name" />
      <FileUploaderInput
        source="fileId"
        label="Attach Universal Document to this Label"
        fileDataSource="_file"
        fileType={FileType.PROJECT_DOCUMENT}
      />
    </FormTemplate>
  );
}

export function CreateDocumentLabelButton() {
  const popupManager = usePopupFormManager();
  return (
    <Button
      text="Create Label"
      size={ButtonSize.MEDIUM}
      iconType={IconType.PLUS}
      color={ButtonColor.BLUE}
      onClick={() => popupManager.openForm(<CreateDocumentLabelForm />)}
      isFilled
    />
  );
}
